import React, { FunctionComponent } from 'react';
import { Icon, SemanticCOLORS } from 'semantic-ui-react';
import { FormattedNumber } from 'react-intl';
import { ConfidenceVals, StatSigExperiment } from 'hooks/useMerchants';

type Props = {
  data: StatSigExperiment;
  className?: string;
};

const resultConfidence = {
  0: 'green',
  1: 'yellow',
  2: 'red',
};

export const getColorFromResultConfidence = (
  confidence: ConfidenceVals,
): SemanticCOLORS => resultConfidence[confidence] as SemanticCOLORS;

const StatSig: FunctionComponent<Props> = ({ data, className }) => {
  const { resultConfidence, numTransactors } = data;
  const notStatSig = resultConfidence === 2;

  return (
    <div className={className}>
      <Icon
        size="small"
        name="circle"
        color={getColorFromResultConfidence(resultConfidence)}
      />

      <span className="statSigDescription">
        <span>
          {notStatSig ? 'Not stat sig and ' : 'Stat sig and '}
          <FormattedNumber value={numTransactors} /> unique transactors
        </span>
      </span>
    </div>
  );
};

export default StatSig;
